var site = site || {};
(function ($) {
  site.locator = site.locator || {};

  site.locator.geocodeResultFilter = function(geocodeResults) {
    var unacceptableMatches = {
          'country': true,
          'route': true,
        },
        unacceptablePartialMatches = {
          'point_of_interest': true,
          'premise': true,
          'subpremise': true,
        },
        results = [];

    jQuery.each(geocodeResults, function(i, returnedResult) {
      var isPartialMatch = returnedResult.partial_match;
      var isUnacceptableOrPartial = false;
      jQuery.each(returnedResult.types, function(j, geoType) {
        if (unacceptableMatches[geoType] || (isPartialMatch && unacceptablePartialMatches[geoType])) {
          isUnacceptableOrPartial = true;
          return false; // exit loop early
        }
        return true;
      });
      if (!isUnacceptableOrPartial) {
        results.unshift(returnedResult);

        return false;
      }

      return true;
    });
    return results;
  };

  // factory function, for CL map pins for store locator
  site.locator.MapLocationIcon = (function () {
    var MapLocationIcon = function (args) {
        this.id = args.id;
        this.label = args.label; // the content to be fetured inside the custom map pin
        this.icon_class = args.icon_class; //the position of the spritesheet for the icon background
        this.pos = args.latlng;
        this.set("position", args.latlng);
        this.setMap(args.map);
        this.clickHandler = args.clickHandler;
      },
      initialize = function () {
        MapLocationIcon.prototype = new google.maps.OverlayView();
        MapLocationIcon.prototype.onRemove = function () {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        };

        //prepare the overlay with DOM
        MapLocationIcon.prototype.onAdd = function () {
          div = document.createElement('div');
          $(div).addClass('map-marker').addClass(this.icon_class);
          $(div).css({
            'position': 'absolute'
          });
          $(div).text(this.label);
          $(div).click(this.clickHandler);

          this.div = div;

          var panes = this.getPanes();
          panes.overlayImage.appendChild(div);
        }

        //set position
        MapLocationIcon.prototype.draw = function() {
          var overlayProjection = this.getProjection();
          var position = overlayProjection.fromLatLngToDivPixel(this.pos);
          var panes = this.getPanes();
          $(this.div).css({
            'left': position.x - 14.5 + 'px',
            'top':  position.y - 44 + 'px'
          });
        }
      },
      initialized = false;

      return function (args) {
        if (!initialized) {
          if (google.maps) {
            initialize();
            initialized = true;
          } else {
            throw new Error("Can't instantiate MapLocationIcon: google.maps is not yet available.");
          }
        }

        return new MapLocationIcon(args);
      };
  }());
})(jQuery);

